module.exports = __webpack_public_path__ + "static/dp-logo-large-white-84e68bc677aa021d896c88d7b5c179aa.svg";